export default (state = {}, action = {}) => {
  const {type, payload = {}} = action;
  switch (type) {
    default: {
      if (payload.vendor_advance_types) {
        return {...state, ...payload.vendor_advance_types};
      }
      return state;
    }
  }
};
